import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonthlySettelState = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 2.32227,
			width: 16.4839,
			height: 16.4839,
			rx: 3.5,
			stroke: "#576706"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.41935 2.04839V0.7C6.41935 0.589543 6.32981 0.5 6.21935 0.5H4.29677C4.18631 0.5 4.09677 0.589543 4.09677 0.7V2.04839",
			stroke: "#576706"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3871 2.04839V0.7C13.3871 0.589543 13.2976 0.5 13.1871 0.5H11.2645C11.1541 0.5 11.0645 0.589543 11.0645 0.7V2.04839",
			stroke: "#576706"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 17.2581,
			y1: 7.19336,
			x2: .225805,
			y2: 7.19336,
			stroke: "#576706"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.0161,
			y: 11.8379,
			width: 3.64516,
			height: 3.64516,
			rx: .5,
			stroke: "#576706"
		})
	]
});
export default SvgMonthlySettelState;
